/**
 * The book an upload should land on.
 * Series Docs and series altitude stay unbound.
 * A book URL counts even before currentStory hydrates. A Discovery
 * sitting's story id counts the same way.
 */

const BOOK_URLS = [
  /^\/plottrack\/([^/]+)/,
  /^\/(?:tasks|path)\/([^/]+)/,
  /^\/bring-into-book\/([^/]+)/,
  /^\/style-cards\/([^/]+)/,
  /^\/story-rules\/([^/]+)/,
  /^\/scene-writing\/([^/]+)/,
  /^\/board\/([^/]+)/,
  /^\/projects\/[^/]+\/stories\/([^/]+)\/(?:notes|docs-offers)\/?$/,
];

export function uploadBookId({
  pathname = '',
  currentStory = null,
  currentSession = null,
  atSeriesAltitude = false,
  onProjectNotes = false,
} = {}) {
  if (atSeriesAltitude || onProjectNotes) return null;
  for (const pattern of BOOK_URLS) {
    const match = (pathname || '').match(pattern);
    if (match?.[1]) return match[1];
  }
  return currentStory?.id || currentSession?.story_id || null;
}
